import React from "react";
import { Stack } from "@mui/material";
import SetupGuideCard from "./SetupGuideCard";

const guides = [
  {
    title: "How to setup your new Nightscout with AndroidAPS",
    links: [
      {
        text: "AndroidAPS Docs Nightscout Setup",
        href: "https://androidaps.readthedocs.io/en/latest/SettingUpAaps/Nightscout.html",
      },
    ],
    videoSrc: undefined,
  },
  {
    title: "How to setup your new Nightscout with iLoop",
    links: [
      {
        text: "xDripiOS Docs Nightscout Setup",
        href: "https://xdrip4ios.readthedocs.io/en/latest/connect/follower/",
      },
      {
        text: "LoopDocs Adding Nightscout",
        href: "https://loopkit.github.io/loopdocs/loop-3/services/#services-for-the-loop-app",
      },
    ],
    videoSrc: undefined,
  },
  {
    title: "How to setup your new Nightscout with Trio",
    links: [
      {
        text: "Trio Nightscout Setup",
        href: "https://docs.diy-trio.org/en/latest/settings/services/nightscout.html#trio-setup",
      },
      {
        text: "xDripiOS Docs Nightscout Setup",
        href: "https://xdrip4ios.readthedocs.io/en/latest/connect/follower/",
      },
    ],
    videoSrc: undefined,
  },
];

const SetupGuide = () => {
  return (
    <Stack spacing={2}>
      {guides.map((guide, index) => (
        <SetupGuideCard
          key={index}
          title={guide.title}
          links={guide.links}
          videoSrc={guide?.videoSrc ?? undefined}
        />
      ))}
    </Stack>
  );
};

export default SetupGuide;
